import { useState } from "react";
import _ from "lodash";
import { callApiIO } from "../../api";
import { useAuth } from "../useAuth";

export default () => {
  const [tagsD, setTagsD] = useState([]);
  const { selectedBusiness } = useAuth();
  const useTags = async () => {
    try {
      const res = await callApiIO(
        `/protected/business/${selectedBusiness.id
        }/iorequest?dest=${encodeURIComponent(
          "business/:BID:/network/:NID:/getTags"
        )}`
      );

      if (res && res.status === true) {
        // Mahima's tags group not being split into unique individual tags fix
        const tags = [];
        res?.data?.forEach((x) => {
          const tag = x.tags.split(",");
          tag.forEach((t) => {
            if (!tags.includes(t)) {
              tags.push(t?.trim());
            }
          });
        });
        // Converting back to same format as was previously for tagsD
        const uniqueTags = _.uniq(tags)?.map(x => ({ tags: x }))
        // setTagsD(res?.data);
        setTagsD(uniqueTags);
        return res?.data;
      }
      return null;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log("error", e);
      return null
    }
  };

  return {
    useTags,
    tagsD,
  };
};
